import { SpinnerComponent } from "@zenith/components";

export const SpinnerModalComponent = ({
  isLoading,
}: {
  isLoading: boolean;
}) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="flex flex-col items-center rounded-lg bg-white p-8">
        <SpinnerComponent size={64} type="primary" />
        <p className="mt-4 text-lg">Confirming Payment...</p>
      </div>
    </div>
  );
};
